export type UrlPath<T> = string & { _?: T } // Basically a string.  The second clause is to peg the generic type


export const rootPath: UrlPath<{}> = "/"
export const testpagePath: UrlPath<{}> = "/testpage"

export const walletConnectPath: UrlPath<{}> = "/assets/:assetChain/:assetWalletAddress"
export const assetDetailsPath: UrlPath<{}> = "/proxyTokenInit/:assetChain/:assetWalletAddress/:assetContractAddress/:assetId"

export const proxyTokensPath: UrlPath<{}> = "/proxy-tokens-list"
export const tokenDetailsPath: UrlPath<{}> = "/proxy-token-details/:assetChain/:assetWalletAddress/:assetContractAddress/:assetId"
// export const tokenDetailsPath: UrlPath<{}> = "/proxy-token-details/:tokenId"

export const verifyPath: UrlPath<{}> = "/verify"
export const verifyPagePath: UrlPath<{}> = "/verify/:assetChain/:assetWalletAddress/:assetContractAddress/:assetId/:proxyTokenId"

export const burnTokenPath: UrlPath<{}> = "/burn-token"
export const burnTokenPagePath: UrlPath<{}> = "/burn-token/:assetChain/:assetWalletAddress/:assetContractAddress/:assetId/:proxyTokenId"

export const privacyPath: UrlPath<{}> = "/privacy-policy"
export const termsPath: UrlPath<{}> = "/terms"

export const browserNotSupported: UrlPath<{}> = "/browser-not-supported"
